<div class="recaptcha">
  <div class="recaptcha__header">
    <div class="recaptcha__brand">
      <mat-icon class="recaptcha__logo" aria-hidden="true">security</mat-icon>
      <span class="recaptcha__title">reCAPTCHA</span>
    </div>
    <button type="button" class="recaptcha__close" mat-icon-button (click)="skipHumanity()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="recaptcha__body">
    <p class="recaptcha__instruction">
      Select all squares with
      <strong>a handsome stud</strong>
      <span class="recaptcha__hint">Click a square to select or deselect it, then VERIFY.</span>
    </p>

    <div class="recaptcha__grid" role="group" aria-label="Image challenge">
      @for (tile of tiles; track $index) {
        <button
          type="button"
          class="tile tile--slice"
          [class.tile--selected]="tile.selected"
          (click)="toggle($index)"
          [attr.aria-pressed]="tile.selected"
          [attr.aria-label]="'Image ' + ($index + 1)"
          [style.background-image]="'url(' + imageSrc + ')'"
          [style.background-size]="cols * 100 + '% ' + rows * 100 + '%'"
          [style.background-position]="spritePosition(tile.col, tile.row)"
          [style.background-repeat]="'no-repeat'"
        >
          @if (tile.selected) {
            <span class="tile__check" aria-hidden="true">
              <mat-icon>check</mat-icon>
            </span>
          }
        </button>
      }
    </div>

    @if (errorHint) {
      <p class="recaptcha__error" role="alert">Please select all matching squares.</p>
    }

    <div class="recaptcha__footer">
      <div class="recaptcha__fineprint">
        <mat-icon class="recaptcha__tiny-icon" aria-hidden="true">info</mat-icon>
        <span>One photo split into 12 squares. Select the column with the handsome stud.</span>
      </div>
      <div class="recaptcha__actions">
        <button mat-stroked-button type="button" (click)="skipHumanity()">Cancel</button>
        <button mat-flat-button color="primary" type="button" (click)="verify()">VERIFY</button>
      </div>
    </div>
  </div>
</div>
